const TopJson = [
    {
        Heading: "Mutual Fund",
        url: "/",
        internal: true,
        filter: "MF"
    },
    {
        Heading: "Index Fund",
        url: "/index-fund",
        internal: true,
        filter: "Index"
    },
    {
        Heading: "ETF",
        url: "/etf-fund",
        internal: true,
        filter: "ETF"
    },
    {
        Heading: "PMS",
        url: process.env.REACT_APP_PMS_MODULE_URL,
        internal: false,
        filter: ""
    },
    {
        Heading: "AIF",
        url: process.env.REACT_APP_AIF_MODULE_URL,
        internal: false,
        filter: "AIF"
    },
    {
        Heading: "PARTNER",
        url: process.env.REACT_APP_PARTNER_MODULE_URL,
        internal: false,
        filter: "partner"
    },
    {
        Heading: "INVESTOR EDUCATION",
        url: "/investor-education/",
        internal: false,
        filter: "investor"
    },
    {
        Heading: "INTERNATIONAL BUSINESS",
        url: "/InternationalBusiness",
        internal: true,
        filter: "international"
    }
]
export default TopJson